import { ActionReducer, createAction, props } from '@ngrx/store';

export const userBlockChanged = createAction('[User Blocks] Changed', props<{ userId: number; blocked: boolean }>());

/** Drop content snapshots and pending card selections; subsequent reads are filtered by the server. */
export function blockContentMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    const next = reducer(state, action);
    if (action.type !== userBlockChanged.type) return next;
    const userId = (action as ReturnType<typeof userBlockChanged>).userId;
    const clean = (items: any[] | undefined) => items?.filter(item => (item.userId ?? item.user?.id) !== userId);
    const user = next.auth?.user;
    return { ...next,
      auth: { ...next.auth, loadingUser: false, user: user ? { ...user, cars: clean(user.cars), realEstates: clean(user.realEstates), likedCars: clean(user.likedCars), likedRealEstates: clean(user.likedRealEstates) } : user },
      car: { ...next.car, car: undefined, carResults: undefined, carMapResults: undefined, topCarResults: undefined,
        listLoading: false, mapLoading: false, topLoading: false },
      realEstate: { ...next.realEstate, realEstate: undefined, propertyResults: undefined, propertyMapResults: undefined,
        topPropertyResults: undefined, listLoading: false, mapLoading: false, topLoading: false },
      users: { ...next.users, user: undefined, users: undefined, loading: false },
    };
  };
}
